var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tag",class:{ 'tag--active': _vm.tag.active },domProps:{"innerHTML":_vm._s(_vm.tag.name)},on:{"click":_vm.clickHandler}},[_c('div',{staticClass:"tag__icon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }